export default "__VITE_ASSET__DhAumu3H__"